module.exports = __webpack_public_path__ + "static/media/icon-status-delivered.63ac1b44.svg";